import { Tag } from "antd";

const normalizeStatus = (status?: string) =>
  status?.trim().toLowerCase() ?? "";

export const getAdminStatusLabel = (status?: string) => {
  const s = normalizeStatus(status);
  if (s === "approved") return "Approved";
  if (s === "pending") return "Pending";
  if (s === "inreview" || s === "in_review" || s === "requested") {
    return "In Review";
  }
  if (s === "rejected") return "Rejected";
  return status || "Pending";
};

export const getEventStatusLabel = (status?: string) => {
  const s = normalizeStatus(status);
  if (s === "published") return "Published";
  if (s === "approved") return "Approved";
  if (s === "draft") return "Draft";
  if (s === "submitted" || s === "requested") return "Submitted";
  if (s === "rejected") return "Rejected";
  if (s === "scheduled") return "Scheduled";
  if (s === "completed") return "Completed";
  if (s === "archived") return "Archived";
  if (!s) return "";
  return s.charAt(0).toUpperCase() + s.slice(1);
};

export function getEventStatusColor(status?: string): string {
  const s = normalizeStatus(status);
  if (s === "approved" || s === "completed") return "green";
  if (s === "published") return "cyan";
  if (s === "rejected") return "red";
  if (s === "draft") return "default";
  if (s === "submitted" || s === "requested") return "blue";
  if (s === "scheduled") return "gold";
  if (s === "archived") return "default";
  return "default";
}

export function getAdminStatusColor(status?: string): string {
  const s = normalizeStatus(status);
  if (s === "approved") return "green";
  if (
    s === "pending" ||
    s === "inreview" ||
    s === "in_review" ||
    s === "requested"
  ) {
    return "gold";
  }
  if (s === "rejected") return "red";
  return "default";
}

type StatusBadgeProps = {
  status?: string;
  type: "admin" | "event";
};

export default function StatusBadge({ status, type }: StatusBadgeProps) {
  if (!status) return null;

  const label =
    type === "admin" ? getAdminStatusLabel(status) : getEventStatusLabel(status);
  const color =
    type === "admin" ? getAdminStatusColor(status) : getEventStatusColor(status);

  return (
    <Tag
      color={color}
      bordered={false}
      style={{
        margin: 0,
        fontWeight: 600,
        textTransform: "capitalize",
        boxShadow: "0 1px 4px rgba(0,0,0,0.12)",
      }}
    >
      {label}
    </Tag>
  );
}
